import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchProcessedAdsByGroupProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchProcessedAdsByGroup = (filters: FetchProcessedAdsByGroupProps) => void;

const fetchProcessedAdsByGroup = ({
  startDate,
  endDate,
  report
}: FetchProcessedAdsByGroupProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport(report, dispatch, params);
};

export default fetchProcessedAdsByGroup;
